import rocketSoundMp3 from "@rosette/assets/src/audio/firework_rocket.mp3";
import rocketSoundWebm from "@rosette/assets/src/audio/firework_rocket.webm";
import explodeSoundMp3 from "@rosette/assets/src/audio/firework_explode.mp3";
import explodeSoundWebm from "@rosette/assets/src/audio/firework_explode.webm";
import type { AudioAsset } from "@/components/assets/AudioAsset.js";
import type { AssetLoader } from "@/components/assets/AssetLoader.js";

export class FireworksResources {
    private readonly rocketSound: AudioAsset;
    private readonly explodeSound: AudioAsset;

    constructor(assetLoader: AssetLoader) {
        this.rocketSound = assetLoader.loadAudio(
            [rocketSoundMp3, rocketSoundWebm], { pool: 2 },
        );
        this.explodeSound = assetLoader.loadAudio(
            [explodeSoundMp3, explodeSoundWebm], { pool: 2 },
        );
    }

    getRocketSound(): AudioAsset {
        return this.rocketSound;
    }

    getExplodeSound(): AudioAsset {
        return this.explodeSound;
    }
}
